import { render, staticRenderFns } from "./InformationStep.vue?vue&type=template&id=1b3b0d24&scoped=true"
import script from "./InformationStep.vue?vue&type=script&lang=js"
export * from "./InformationStep.vue?vue&type=script&lang=js"
import style0 from "./InformationStep.vue?vue&type=style&index=0&id=1b3b0d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3b0d24",
  null
  
)

export default component.exports